import styled, { css } from "styled-components";
import React, { Component } from "react";
import { _ } from "js/vendor";
import { SearchBar } from "js/react/views/AddSlide/Panes/Components/SearchBox";
import { FlexSpacer, Gap10, Gap20, Gap30 } from "js/react/components/Gap";
import { Fragment } from "react";
import { Icon, IconButton, MenuItem, Slider } from "@mui/material";
import { IconMenu } from "js/react/components/UiComponents";
import { themeColors } from "js/react/sharedStyles";
import { app } from "js/namespaces";

const StyledLibraryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  //flex-grow: 2;
  //padding-right: 30px;
  .material-icons {
    color: #11A9E2;
  }
`;

const StyledSearchBar = styled(SearchBar)`

    ${props => props.$isMobile && `
        padding: 0;
    `}
`;

const iconMenuStyles = css`
    &&& {
        padding: 0;
    }
`;

const StyledIconMenu = styled(IconMenu)`
    ${iconMenuStyles};
`;

const StyledIconButton = styled(IconButton)`
    ${iconMenuStyles};
`;
export class PresentationListHeader extends Component {
    constructor(props) {
        super();

        this.state = {
            thumbnailSize: props.thumbnailSize
        };

        this.searchBarRef = React.createRef();
    }

    handleSetSort = sort => {
        this.props.onSetSort && this.props.onSetSort(sort);
    }

    handleSearch = value => {
        this.props.onSearch && this.props.onSearch(value);
    }

    toggleViewType = () => {
        const viewType = this.props.viewType == "grid" ? "list" : "grid";
        this.props.onSetViewType && this.props.onSetViewType(viewType);
    }

    handleShowSearchBar = () => {
        const { onSearchBarOpen } = this.props;
        onSearchBarOpen && onSearchBarOpen();

        this.setState({ showSearchBar: true }, () => {
            this.searchBarRef.current?.focusInput();
        });
    }

    handleHideSearchBar = () => {
        this.setState({ showSearchBar: false });
    }

    render() {
        let { showSearchBar } = this.state;
        let { sortOptions, viewType = "grid", className = "" } = this.props;

        return (
            <StyledLibraryHeader className={className}>
                <IconButton size="small" onClick={this.handleShowSearchBar}
                    style={{ color: themeColors.ui_blue }}><Icon>search</Icon></IconButton>

                {(showSearchBar || app.isMobileOrTablet) &&
                    <Fragment>
                        <StyledSearchBar
                            ref={this.searchBarRef}
                            showIcon={false}
                            placeholder="Search presentations"
                            onSearch={this.handleSearch}
                            onBlurOnEmpty={this.handleHideSearchBar}
                            $isMobile={app.isMobileOrTablet}
                        />
                    </Fragment>
                }
                {
                    (viewType == "grid" || app.isConstrained) &&
                    <Fragment>
                        {
                            !app.isConstrained &&
                            <Gap20 />
                        }
                        {
                            !app.isMobileOrTablet &&
                            app.integrator &&
                            <Gap10 />
                        }
                        <StyledIconMenu icon="sort" $isMobile={app.isMobileOrTablet}>
                            {sortOptions.map(option => (
                                <MenuItem
                                    key={option.value}
                                    selected={this.props.sort.field === option.value}
                                    onClick={() => this.handleSetSort({
                                        field: option.value,
                                        reverse: option.reverse
                                    })}>
                                    {option.icon && <Icon>{option.icon}</Icon>}
                                    {option.label}
                                </MenuItem>
                            ))}
                        </StyledIconMenu>
                    </Fragment>
                }

                {
                    !app.isConstrained &&
                    <Fragment>
                        <Gap20 />
                        <StyledIconButton onClick={() => this.toggleViewType()}>
                            <Icon>{viewType == "grid" ? "view_module" : "view_list"}</Icon>
                        </StyledIconButton>
                    </Fragment>
                }
                {
                    app.isConstrained &&
                    <Fragment>
                        <StyledIconButton onClick={() => this.toggleViewType()} $isMobile={app.isMobileOrTablet}>
                            <Icon>{viewType == "grid" ? "view_module" : "view_list"}</Icon>
                        </StyledIconButton>
                    </Fragment>
                }
            </StyledLibraryHeader>
        );
    }
}
